import { render, staticRenderFns } from "./TelephonyActionRedirect.vue?vue&type=template&id=1df82412"
import script from "./TelephonyActionRedirect.vue?vue&type=script&lang=ts"
export * from "./TelephonyActionRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports